import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Modal, ModalControlResponse, Text } from '@frontend/design-system';
import CreateFormLoader from '../loader/loader.component';
import { useCreateFormStepsStore } from '../provider';
import LocationPickerStepFooter, { LocationPickerStepFooterProps } from './footer/footer.component';
import TemplateLocationPicker from './location-picker/location-picker.component';

export interface LocationPickerStepProps extends LocationPickerStepFooterProps {
  modalControls: ModalControlResponse;
  usableLocationIds: string[];
}

const LocationPickerStep: FC<LocationPickerStepProps> = ({ modalControls, usableLocationIds, onSave }) => {
  const { t } = useTranslation('forms');
  const { isCreatingForm } = useCreateFormStepsStore(['isCreatingForm']);

  return (
    <Modal
      {...modalControls.modalProps}
      disableCloseOnEscape={isCreatingForm}
      disableCloseOnOverlayClick={isCreatingForm}
    >
      <Modal.Header>{t('Choose Location')}</Modal.Header>
      <Modal.Body>
        <Text>
          {t(
            `You have ${usableLocationIds.length} active locations. Select where you would like to save this template`
          )}
        </Text>
        <TemplateLocationPicker usableLocationIds={usableLocationIds} />
      </Modal.Body>
      <LocationPickerStepFooter onSave={onSave} />
      <CreateFormLoader />
    </Modal>
  );
};

export default LocationPickerStep;
